import { Badge, Chip } from "@mui/material";
import { Datagrid, DateField, FunctionField, List, TextField } from "react-admin";

type ThreadRecord = {
  id: string;
  user_phone: string | null;
  user_name: string | null;
  user_username: string | null;
  last_message_preview: string | null;
  unread_admin: number;
};

function ClientField() {
  return (
    <FunctionField
      label="Клиент"
      render={(r: ThreadRecord) =>
        r.user_name || r.user_phone || (r.user_username ? `@${r.user_username}` : "—")
      }
    />
  );
}

export function SupportList() {
  return (
    <List
      sort={{ field: "last_message_at", order: "DESC" }}
      perPage={25}
      exporter={false}
      empty={false}
    >
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <FunctionField
          label=""
          render={(r: ThreadRecord) =>
            r.unread_admin > 0 ? <Badge color="error" badgeContent={r.unread_admin} /> : null
          }
        />
        <ClientField />
        <TextField source="last_message_preview" label="Последнее сообщение" />
        <DateField source="last_message_at" label="Обновлён" showTime />
        <FunctionField
          label="Статус"
          render={(r: { status: string }) =>
            r.status === "closed" ? (
              <Chip size="small" label="Закрыт" />
            ) : (
              <Chip size="small" color="success" label="Открыт" />
            )
          }
        />
      </Datagrid>
    </List>
  );
}
